import { render, staticRenderFns } from "./ClientesProveedores.vue?vue&type=template&id=7dcfd540&"
import script from "./ClientesProveedores.vue?vue&type=script&lang=ts&"
export * from "./ClientesProveedores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports